export const numberFormatter = (number: number): string => {
  return number.toLocaleString();
};